// extracted by mini-css-extract-plugin
export default {"wrap":"AddressKrModal_wrap__k6CKW"};